import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App'; // App component is automatically created with create-react-app
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();
